"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _confirmWithdrawActions = require("../../redux/actions/confirmWithdrawActions");
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
var _ConfirmWithdrawComponent = _interopRequireDefault(require("./ConfirmWithdrawComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var processingConfirmWithdraw = state.apiProcessing.processingConfirmWithdraw,
    _state$confirmWithdra = state.confirmWithdraw,
    message = _state$confirmWithdra.message,
    error = _state$confirmWithdra.error;
  return {
    processingConfirmWithdraw: processingConfirmWithdraw,
    message: message,
    error: error
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = (0, _queryParamsHelper.getQueryParam)('d1');
  var userid = (0, _queryParamsHelper.getQueryParam)('UserId');
  var verifycode = (0, _queryParamsHelper.getQueryParam)('verifycode');
  return {
    fetchConfirmWithdraw: function fetchConfirmWithdraw() {
      return dispatch((0, _confirmWithdrawActions.fetchConfirmWithdraw)({
        verifycode: verifycode,
        userid: userid,
        d1: d1
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmWithdrawComponent["default"]);